import { mapGetters } from 'vuex'
import errorNotifications from '@/mixins/errorNotifications'

export default {
  mixins: [errorNotifications],
  data() {
    return {
      snackbar: {
        show: false,
        text: '',
        color: '',
      },
    }
  },
  computed: {
    ...mapGetters(['appSavitarna']),
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
  },
  created() {
    this.$root.$on('SHOW_SNACKBAR', (e) => {
      this.snackbar = {
        show: true,
        text: e.text,
        color: e.color,
      }
    })
    this.$on('GO_TO_404', (e) => {
      if (this.appSavitarna) {
        this.$router.push({ name: 'sav404' })
      } 
    })
    this.$on('AUTH_FAILED', (e) => {
      if (this.appSavitarna) {
        this.$root.$emit('SAV_UNAUTHORIZED_ERROR')
      } else {
        this.$router.push({ name: 'login' })
      }
    })
    this.$root.$on('SERVER_ERROR', () => {
      this.snackbar = {
        show: true,
        text: this.$t('Serverio klaida'),
        color: 'error',
      }
    })
    this.$root.$on('FORMAT_ERROR', () => {
      this.snackbar = {
        show: true,
        text: this.notificationText('000108'),
        color: 'error',
      }
    })

    this.$root.$on('FORMAT_ERROR_STEP', () => {
      this.snackbar = {
        show: true,
        text: this.notificationText('000007'),
        color: 'error',
      }
    })

    this.$root.$on('FILE_EXTENSION_NOT_ALLOWED', () => {
      this.snackbar = {
        show: true,
        text: `${this.notificationText('000107')} ${sessionStorage.getItem('file_types')}`,
        color: 'error',
      }
    })

    this.$root.$on('FILE_TOO_LARGE', () => {
      let size = Math.round(sessionStorage.getItem('max_file_size') / 1048576, 2) + ' MB'
      this.snackbar = {
        show: true,
        text: `${this.notificationText('000106')} ${size}`,
        color: 'error',
      }
    })

    this.$root.$on('DATA_ERROR', (err) => {
      if (
        !err ||
        !err.response ||
        !err.response.data
      ) {
        this.$root.$emit('SERVER_ERROR')
        return
      }
      const errors = err.response.data.errors
      const fields = err.response.data?.fields || null
      this.snackbar = {
        show: true,
        multiple: errors,
        fields: fields,
        color: 'error',
        timeout: 6000,
      }
    })

    this.$root.$on('DATA_ERROR_CODE', (code) => {
      this.snackbar = {
        show: true,
        text: this.notificationText(code),
        color: 'error',
      }
    })

    this.$root.$on('DATA_ERROR_TEXT', (message) => {
      this.snackbar = {
        show: true,
        text: this.$t(message),
        color: 'error',
      }
    })

    this.$root.$on('DATA_INFO_TEXT', (message) => {
      this.snackbar = {
        show: true,
        text: this.$t(message),
        color: 'info',
      }
    })

    this.$root.$on('DATA_ERROR_DIRECT_TEXT', (message) => {
      this.snackbar = {
        show: true,
        text: message,
        color: 'error',
      }
    })

    this.$root.$on('DATA_OK', (message) => {
      this.snackbar = {
        show: true,
        text: this.$t(message),
        color: 'success',
      }
    })

    this.$root.$on('DATA_OK_CODE', (code) => {
      this.snackbar = {
        show: true,
        text: this.notificationText(code),
        color: 'success',
      }
    })

    this.$root.$on('DATA_OK_STEP', () => {
      this.snackbar = {
        show: true,
        text: this.notificationText('000008'),
        color: 'success',
      }
    })
    
    this.$root.$on('SAV_INCAPACITATED_ERROR', () => {
      this.snackbar = {
        show: true,
        text: this.notificationText('000002'),
        color: 'error',
      }
      setTimeout(() => {
        window.location.href = `${process.env.VUE_APP_SAVITARNA_GLOBAL_URL}goto.do?menuId=1`
      }, 3000)
    })

    this.$root.$on('SAV_LOGIN_ERROR', () => {
      window.location.href = `${process.env.VUE_APP_SAVITARNA_GLOBAL_URL}`
    })
    this.$root.$on('SAV_SESSION_ERROR', () => {
      window.location.href = `${process.env.VUE_APP_SAVITARNA_GLOBAL_URL}showError.do?errorView=errorSessionExpire`
    })
    this.$root.$on('SAV_UNAUTHORIZED_ERROR', () => {
      window.location.href = `${process.env.VUE_APP_SAVITARNA_GLOBAL_URL}`
    })
  },
  mounted() {
    if (typeof window !== undefined && window._VMA === undefined) {
      window._VMA = this
    }
  },
}
